<template>
  <div class="index" style="padding: 10px">
    <div style="display: flex; line-height: 41px; font-size: 14px">
      <Tabs
        style="margin-bottom: 18px; margin-left: 15px"
        value="1"
        @on-click="switchover"
      >
        <TabPane label="今日" name="1"> </TabPane>
        <TabPane label="昨日" name="2"></TabPane>
        <TabPane label="本月" name="3"></TabPane>
        <TabPane label="上月" name="4"></TabPane>
        <TabPane label="全部" name="5"></TabPane>
      </Tabs>
      <div class="search_list" style="margin-left: 30px">
        <div class="text">按时间查询:</div>
        <DatePicker
          type="daterange"
          split-panels
          class="select"
          @on-change="queryTime"
        ></DatePicker>
      </div>
      <div style="margin-left: 40px; font-size: 18px; font-weight: 900">
        合计:{{ total }}
      </div>
    </div>

    <div class="content">
      <div class="list" v-for="(item, index) in data">
        <div
          style="
            display: flex;
            align-items: center;
            border-bottom: 1px solid #e7e6e6;
            padding: 7px 0px;
          "
        >
          <img :src="item.data[0].logo" alt="" srcset="" />
          <div style="font-size: 16px; font-weight: 600; margin-left: 10px">
            {{ item.data[0].productName.slice(0, 2) }}
          </div>
          <div
            style="
              color: #1e88e4;
              font-size: 20px;
              font-weight: 600;
              margin-left: 60px;
              margin-right: 32px;
              width: 60px;
              text-align: center;
            "
          >
            {{ item.total }}
          </div>
        </div>
        <div style="display: flex; flex-wrap: wrap">
          <div v-for="(list, i) in item.data">
            <div
              style="
                display: flex;
                justify-content: space-between;
                width: 220px;
                margin-left: 20px;
                font-size: 14px;
                line-height: 44px;
                font-weight: 600;
              "
            >
              <div>{{ list.productName }}</div>
              <div style="color: #e64a19; font-size: 19px; margin-right: 20px">
                {{ list.count }}<span v-if="list.ey != 0">/{{ list.ey }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 20px; width: 100%"></div>
    </div>
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      data: {},
      total: "",
      time: 1,
    };
  },
  mounted: function () {
    Date.prototype.format = function (fmt) {
      var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (this.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    };
    this.getData(
      new Date(new Date().toLocaleDateString()).format("yyyy-MM-dd hh:mm:ss"),
      new Date(Date.parse(new Date().toLocaleDateString()) + 86400000).format(
        "yyyy-MM-dd hh:mm:ss"
      )
    );
    this.style2();
  },
  methods: {
    queryTime(time) {
      if (time[0]) {
        this.getData(
          new Date(Date.parse(new Date(time[0])) - 28800000).format(
            "yyyy-MM-dd hh:mm:ss"
          ),
          new Date(Date.parse(new Date(time[1])) + 57600000).format(
            "yyyy-MM-dd hh:mm:ss"
          )
        );
      }
    },
    getStartTime() {
      let date = new Date();
      date.setDate(1); // 将当前时间的日期设置成第一天
      let year = date.getFullYear(); // 得到当前年份
      let month = date.getMonth() + 1; // 得到当前月份（0-11月份，+1是当前月份）
      month = month > 10 ? month : "0" + month; // 补零
      let day = date.getDate(); // 得到当前天数，实际是本月第一天，因为前面setDate(1) 设置过了
      // console.log(month) 03
      return new Date(year + "/" + month + "/" + day); // 这里传入的是字符串
    },
    style1() {
      document.getElementsByClassName("ivu-tabs-tab")[0].style.color =
        "#515a6e";
      document.getElementsByClassName("ivu-tabs-tab")[1].style.color =
        "#515a6e";
      document.getElementsByClassName("ivu-tabs-tab")[2].style.color =
        "#515a6e";
      document.getElementsByClassName("ivu-tabs-tab")[3].style.color =
        "#515a6e";
      document.getElementsByClassName("ivu-tabs-tab")[4].style.color =
        "#515a6e";
    },
    style() {
      setTimeout(() => {
        document.getElementsByClassName("ivu-tabs-nav")[0].style.borderRadius =
          "50px";
        document.getElementsByClassName("ivu-tabs-bar")[0].style.border =
          "none";
        document.getElementsByClassName(
          "ivu-tabs-nav-scroll"
        )[0].style.overflow = "initial";
        document.getElementsByClassName("ivu-tabs-nav-wrap")[0].style.overflow =
          "initial";
        document.getElementsByClassName("ivu-tabs-ink-bar")[0].style.height =
          "34px";
        document.getElementsByClassName(
          "ivu-tabs-ink-bar"
        )[0].style.borderRadius = "50px";
        document.getElementsByClassName("ivu-tabs-tab-active")[0].style.color =
          "#fff";
        document.getElementsByClassName("ivu-tabs-tab-active")[0].style.zIndex =
          "10000";
        document.getElementsByClassName("ivu-tabs-nav")[0].style.border =
          "1px solid #ccc";
      }, 100);
    },
    switchover(name) {
      this.time = name;
      this.style();
      this.style1();
      if (this.time == 1) {
        this.getData(
          new Date(new Date().toLocaleDateString()).format(
            "yyyy-MM-dd hh:mm:ss"
          ),
          new Date(
            Date.parse(new Date().toLocaleDateString()) + 86400000
          ).format("yyyy-MM-dd hh:mm:ss")
        );
      }
      if (this.time == 2) {
        this.getData(
          new Date(
            Date.parse(new Date().toLocaleDateString()) - 86400000
          ).format("yyyy-MM-dd hh:mm:ss"),
          new Date(Date.parse(new Date().toLocaleDateString())).format(
            "yyyy-MM-dd hh:mm:ss"
          )
        );
      }
      if (this.time == 3) {
        this.getData(
          new Date(Date.parse(this.getStartTime().toLocaleDateString())).format(
            "yyyy-MM-dd hh:mm:ss"
          ),
          new Date(Date.parse(new Date())).format("yyyy-MM-dd hh:mm:ss")
        );
      }
      if (this.time == 4) {
        let curDate = new Date();
        let y = curDate.getFullYear();
        let m = curDate.getMonth();
        if (m > 12) {
          //月份大于12划为下一年
          m = 1;
          y++;
        }
        if (m === 0) {
          //月份等于0时
          m = 12;
          y--;
        }
        let lastStartDay = y + "/" + (m < 10 ? "0" + m : m) + "/" + "01";

        this.getData(
          new Date(
            Date.parse(new Date(lastStartDay).toLocaleDateString())
          ).format("yyyy-MM-dd hh:mm:ss"),
          new Date(Date.parse(this.getStartTime().toLocaleDateString())).format(
            "yyyy-MM-dd hh:mm:ss"
          )
        );
      }
      if (this.time == 5) {
        this.getData("", "");
      }
    },
    style2() {
      document.getElementsByClassName("ivu-tabs-nav")[0].style.width = "376px";
      document.getElementsByClassName("ivu-tabs-nav")[0].style.paddingLeft =
        "2px";
      document.getElementsByClassName("ivu-tabs-ink-bar")[0].style.background =
        "#191996";
      document.getElementsByClassName("ivu-tabs-ink-bar")[0].style.left = "2px";
    },
    getData(startTime, endTime) {
      api
        .RewardStatistics({
          startTime,
          endTime,
        })
        .then((res) => {
          this.total = 0;
          this.data = [];
          res.body.data.forEach((element, i) => {
            this.data.push({ data: element, total: 0 });
            element.forEach((e) => {
              this.total += e.total;
              this.data[i].total += e.total;
              e.count = 0;
              e.ey = 0;
              e.statisticsList.forEach((f) => {
                if (f.settlementType == 1 || f.settlementType == 2) {
                  e.count += f.count;
                }
                if (f.settlementType == 3) {
                  e.ey += f.count;
                }
              });
            });
          });
          this.style();
        });
    },
  },
};
</script>

<style scoped>
.index {
  color: #000;
  height: 800px;
  border-radius: 10px;
  background: #fff;
}
.content {
  height: 150px;
  width: 100%;
  align-items: baseline;
  display: flex;
  flex-wrap: wrap;
}
.list {
  border: 1px solid #e7e6e6;
  border-radius: 5px;
  margin-right: 30px;
  margin-bottom: 30px;
}
.list img {
  width: 25px;
  margin-left: 20px;
}
.title {
  margin-left: 15px;
  font-size: 17px;
  font-weight: 600;
}
</style>
